import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import './Admin.css';
import AddNewUserModal from '../../components/admin/AddNewUserModal';
import ConfirmationModal from '../../components/support/ConfirmationModal';
import EditUserModal from '../../components/admin/EditUserModal';
import { Link } from 'react-router-dom';
const API_URL = process.env.REACT_APP_API_URL;
const UserManagementPage = () => {
  const { t } = useTranslation();
  const { token, user: adminUser } = useAuth();

  const [users, setUsers] = useState([]);
  

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  const [roleFilter, setRoleFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [userToDelete, setUserToDelete] = useState(null);

    const fetchUsers = async () => {
    if (!token) return;
    try {
      setError('');
      const query = new URLSearchParams({ role: roleFilter, search: searchTerm, status: statusFilter }).toString();
      const response = await fetch(`${API_URL}/api/support/users?${query}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error(t('error_fetch_users'));
      const data = await response.json();
      setUsers(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
        fetchUsers();
    }, 500); // Debounce
    
    return () => clearTimeout(timer);
  }, [roleFilter, searchTerm, statusFilter, token, t]); // 'fetchUsers' yerine, onu tetikleyen gerçek state'ler

  const handleDeleteUser = async () => {
    if (!userToDelete) return;
    try {
      const response = await fetch(`${API_URL}/api/admin/users/${userToDelete.id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(t(data.messageKey) || t('error_delete_user'));
      }
      alert(t(data.messageKey || 'success_user_deleted'));
      setUserToDelete(null);
      fetchUsers();
    } catch (err) {
      alert(err.message);
      setUserToDelete(null);
    }
  };
  
  const handleUserAdded = () => { setIsAddModalOpen(false); fetchUsers(); };
  const handleUserUpdated = () => { setIsEditModalOpen(false); fetchUsers(); };
  
  const handleOpenEditModal = (user) => {
    setSelectedUserId(user.id);
    setIsEditModalOpen(true);
  };

  const openDeleteModal = (user) => { setUserToDelete(user); };
  const UserRoleBadge = ({ role }) => (<span className={`role-badge role-${role}`}>{t(role)}</span>);
  
  return (
    <>
      <div className="page-container admin-dashboard">
        <div className="page-header modern">
            <h1>{t('user_management')}</h1>
            <button className="add-user-btn-modern" onClick={() => setIsAddModalOpen(true)}>
                <i className="fas fa-plus"></i> {t('add_new_user')}
            </button>
        </div>

        <div className="filters-container-modern">
            <div className="search-bar-modern">
                <i className="fas fa-search"></i>
                <input type="text" placeholder={t('search_user_placeholder')} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            </div>
            <select value={roleFilter} onChange={(e) => setRoleFilter(e.target.value)} className="role-filter-modern">
                <option value="">{t('all_roles')}</option>
                <option value="customer">{t('customer')}</option>
                <option value="translator">{t('translator')}</option>
                <option value="support">{t('support')}</option>
                <option value="admin">{t('admin')}</option>
            </select>
			<select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="role-filter-modern">
                <option value="">{t('all_statuses', 'Tüm Durumlar')}</option>
                <option value="active">{t('status_active', 'Aktif')}</option>
                <option value="disabled">{t('status_disabled', 'Devre Dışı')}</option>
            </select>
        </div>
        
         <div className="admin-table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th className="desktop-cell">ID</th>
                <th className="desktop-cell">{t('full_name')}</th>
                <th className="desktop-cell">{t('email_panel')}</th>
                <th className="desktop-cell">{t('phone')}</th>
                <th className="desktop-cell">{t('role')}</th>
                <th className="desktop-cell">{t('actions')}</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan="6" className="table-row-message"><i className="fas fa-spinner fa-spin"></i> {t('loading_users')}</td></tr>}
              {error && <tr><td colSpan="6" className="table-row-message error">{error}</td></tr>}
              {!loading && users.length === 0 && <tr><td colSpan="6" className="table-row-message">{t('no_users_found')}</td></tr>}
              {!loading && users.map(user => (
                <tr className="table-row" key={user.id}>
                  {/* DÜZELTME: Masaüstü hücreleri artık kendi sınıfına sahip */}
                  <td className="desktop-cell">{user.id}</td>
                  <td className="desktop-cell">{user.first_name} {user.last_name}</td>
                  <td className="desktop-cell">{user.email}</td>
                  <td className="desktop-cell">{`${user.phone_country_code || ''} ${user.phone_number || ''}`}</td>
                  <td className="desktop-cell"><UserRoleBadge role={user.role} /></td>
                  <td className="desktop-cell">
                    <div className="action-buttons">
					{user.role === 'customer' && (
                        <Link 
                          to={`/management/customers/${user.id}`}
                          target="_blank" // Yeni sekmede açmayı sağlar
                          rel="noopener noreferrer" // Güvenlik için eklenmesi önerilir
                          className="action-btn info" // Stil için aynı class'ları kullan
                        >
                          <i className="fas fa-info-circle"></i>
                        </Link>
                      )}
                      <button className="action-btn edit" onClick={() => handleOpenEditModal(user)}><i className="fas fa-pencil-alt"></i> {t('edit')}</button>
                      <button className="action-btn delete" onClick={() => openDeleteModal(user)} disabled={user.id === 1 || user.id === adminUser?.id}><i className="fas fa-trash-alt"></i> {t('delete')}</button>
                    </div>
                  </td>
                  
                 
                  <td className="cell-mobile">
                  
                    <div className="mobile-card-line">
                      <span className="mobile-card-label">{t('full_name')}</span>
                      <span className="mobile-card-value">{user.first_name} {user.last_name}</span>
                    </div>
                    <div className="mobile-card-line">
                      <span className="mobile-card-label">{t('email_panel')}</span>
                      <span className="mobile-card-value">{user.email}</span>
                    </div>
                    <div className="mobile-card-line">
                      <span className="mobile-card-label">{t('phone')}</span>
                      <span className="mobile-card-value">{`${user.phone_country_code || ''} ${user.phone_number || ''}`}</span>
                    </div>
                    <div className="mobile-card-line">
                      <span className="mobile-card-label">{t('role')}</span>
                      <span className="mobile-card-value"><UserRoleBadge role={user.role} /></span>
                    </div>
                    <div className="action-buttons">
					 {user.role === 'customer' && (
                         <Link 
                          to={`/management/customers/${user.id}`}
                          target="_blank" // Yeni sekmede açmayı sağlar
                          rel="noopener noreferrer" // Güvenlik için eklenmesi önerilir
                          className="action-btn info" // Stil için aynı class'ları kullan
                        >
                          <i className="fas fa-info-circle"></i>
                        </Link>
                      )}
                        <button className="action-btn edit" onClick={() => handleOpenEditModal(user)}><i className="fas fa-pencil-alt"></i> {t('edit')}</button>
                        <button className="action-btn delete" onClick={() => openDeleteModal(user)} disabled={user.id === 1 || user.id === adminUser?.id}><i className="fas fa-trash-alt"></i> {t('delete')}</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      
      <AddNewUserModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} onUserAdded={handleUserAdded} />
      
      {isEditModalOpen && (
          <EditUserModal 
            isOpen={isEditModalOpen} 
            onClose={() => setIsEditModalOpen(false)} 
            onUserUpdated={handleUserUpdated}
            userId={selectedUserId}
          />
      )}

      <ConfirmationModal 
        isOpen={!!userToDelete} 
        onClose={() => setUserToDelete(null)} 
        onConfirm={handleDeleteUser} 
        title={t('confirm_delete_user_title')} 
        message={t('confirm_delete_user', { name: `${userToDelete?.first_name} ${userToDelete?.last_name}` })} 
      />
    </>
  );
};

export default UserManagementPage;